
































































import OilImage from './images/oil_bg_detail.png'
import OliveImage from './images/olives_bg_detail.png'

export default

	props: product: Object

	data: ->
		oilImage: OilImage
		oliveImage: OliveImage
		reviewsLoaded: false

	mounted: ->

		# if this is a bundle product, don't show reviews
		return if @product.isBundle

		# there was an ask to have the reviews accordion open
		# on page load. This is to defer loading the Yotpo
		# script for 5 seconds so that the doesn't affect page loading times
		#https://app.asana.com/0/1200777795870740/1201937877256608/f
		@$wait 5000, =>
			if @$refs.reviews? then @$refs.reviews.showReviews()

	computed:

		hideReviews: ->
			if @product?.hideReviews? then return @product.hideReviews

		reviewClasses: -> [
			'hide-reviews' if @hideReviews
		]

		comparison: -> @$store.state.globals.productFields?.comparison

		certifications: ->
			if @product?.certifications?.length then @product?.certifications else false

		tastingNotes: ->
			if @product?.tastingNotes?.length then @product?.tastingNotes else false

		nutritionFacts: ->
			if @product?.nutritionFacts?.length then @product?.nutritionFacts else false

		faqBlock: ->
			faqs: @product.faqs

		ingredients: ->
			if @product?.ingredients?.length then @product?.ingredients else false


